import React, { useState } from 'react'
import { Flexed,Flex, currency, Textarea } from '../utilities/Shared'
import Moment from 'react-moment'
import ReceiveItem from '../pages/po/ReceiveItem'
import Modal from '../modals/Modal'
import {GiReceiveMoney} from 'react-icons/gi'


const InventoryBox = ({items,setupdateitem,poinfo,reset,setReset}) => {

const [receiveshow, setReceiveshow] = useState(false)
const [receiveitem, setReceiveitem] = useState({})

console.log()


const getitemtotals = (item) => {
  console.log(item)
let u = 0

  console.log('new')
item?.receivedHistory?.map(it => {
  u += parseInt(it?.quantity) || 0
})
console.log(u)


return u
}



  return (
<div style={{position:"relative",width:"100%",overflow:"scroll",minHeight:"200px",marginTop:"5px"}}>
<Modal show={receiveshow} header={`Receive Item - ${receiveitem.name}`} onCancel={() => {setReceiveshow(false)}}><ReceiveItem item={receiveitem} poinfo={poinfo} reset={reset} setReset={setReset} setReceiveshow={setReceiveshow} onCancel={() => {setReceiveshow(false)}}/></Modal>
<Flexed width="200%" style={{background:"#0E425A",color:"white",padding:"5px"}} gap="20px">
  <Flex flex=".5"></Flex>
  <Flex flex="2">Item</Flex>

  <Flex flex="1">Outstanding</Flex>
<Flex flex="1">Ordered</Flex>
<Flex flex="1">Received</Flex>
    <Flex>Order Date</Flex>
    <Flex>Receive Date</Flex>
      <Flex flex="2">Description</Flex>
    <Flex>Size</Flex>
    <Flex>Type</Flex>
    <Flex>Unit Price</Flex>
    <Flex>Order Unit</Flex>
    <Flex>Price</Flex>
</Flexed>

{
    items?.map((item,index) => {

     return  <>
    
     {/* <Flexed width="200%" gap="20px" padding="5px" onClick={e => item.recievedstatus === 1 ? "" : setupdateitem(item)} className={item?.receivedoutstanding === 0  ? "receivedrow" : "normalrow"} style={{ "--animation-delay": `${index * 0.2}s` }}> */}
<Flexed
    key={item.id}
    width="200%"
    gap="20px"
    padding="5px"
    onClick={e => (item.receivedstatus === .85 ? "" : setupdateitem(item))}
    className={item?.receivedoutstanding === 0 ? "receivedrow" : "normalrow"}
    style={{
      animationDelay: `${index * 1}s`, // Stagger start times
      animationDuration: `${4 + index * 0.5}s`, // Vary duration (e.g., 4s, 4.5s, 5s, ...)
    }}
  >
    <Flex flex=".5">{item.recievedstatus === 1 ? "" : <GiReceiveMoney style={{fontSize:"20px"}} onClick={() => {setReceiveitem(item);setReceiveshow(true)}} />}</Flex>

    <Flex  flex="2">{item?.name}</Flex>
   
    <Flex flex="1">{item?.receivedoutstanding > 0 ? <div style={{color:"red",fontSize:"calc(.9rem + .2vw)",display:"flex",alignItems:"flex-start",padding:"0",margin:"0",fontWeight:"bold"}}>{item?.receivedoutstanding}</div> : item?.receivedoutstanding}</Flex>
    <Flex  flex="1">{item?.quantity}&nbsp;&nbsp;{item?.orderby}</Flex>
    <Flex  flex="1">{getitemtotals(item)}</Flex>
 
    
    
    <Flex><Moment format="MM/DD/YYYY">{poinfo?.createdAt}</Moment></Flex>
    <Flex>{item?.recieveddate ? <Moment format="MM/DD/YYYY">{item?.recieveddate}</Moment> : ""}</Flex>
     <Flex flex="2" >{item.description?.replace(/&amp;/g, "&")}</Flex>
    <Flex>{item?.width && item?.length ? item.width+" X ": item.width} {item?.length ? item.length: ""}</Flex>
    <Flex>{item?.type || "N/A"}</Flex>
    <Flex>{item?.unitprice || item.perthou}</Flex>
    <Flex>{item?.orderby}</Flex>
    <Flex>{currency(item?.extprice)}</Flex>   
    </Flexed> 
    </>
    })
}
</div>
  )
}

export default InventoryBox